module.exports = __webpack_public_path__ + "img/charleston-advisor.e14d9598.png";